<template>
  <div class="g-layerImg">
    <div class="g-layerBox">
       <a :href="this.url"><img :src="this.imgUrl" alt="" class="g-adImg"></a>
      <p class="g-adBottom">
       <!-- <img src="../assets/adBottom.png" alt=""> -->
        <span>
          推广
        </span>
      </p>
    </div>
    <img src="../assets/icon20.png" alt="" class="u-closeLayer" @click="closeLayer">
    
  </div>
</template>

<script>
export default {
  name:"LayerAd",
  props:{
    imgUrl:String,
    url:[String,Number]
  },
  methods:{
    closeLayer (){
      this.$layer.closeAll("iframe");
    }
  }
}
</script>

<style lang="scss">
.g-layerImg {
  width: 8.5rem;
  
//  background: #ffff;
  margin: 0 auto;
}
.g-layerBox {
  background: #ffff;
  padding: .133333rem;
}
.g-adImg {
  display: block;
 max-width: 100%;
  margin: 0 auto;
}
.u-closeLayer {
  width: .866667rem;
  height: .866667rem;
  display: block;
  margin: 0 auto;
  margin-top: .466667rem;
}
.g-adBottom {
  padding: .2rem 0;
  background: #FFF;
  overflow: hidden;
  display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
  img {
    width: .986667rem;
    height: .333333rem;
    // float: left;
  }
  span {
    // float: right;
    font-size: .24rem;
    color: #878787;
  }
}
</style>